import { useMemo } from 'react';

import { ROUTES } from '@/common';
import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core/hooks';
const useGetUndeliverableURL = () => {
  const {
    observingDefault: { id: defaultId, type: defaultType },
    observingOrganization: { id, type },
  } = useCurrentOrganization();

  const isEmployerObserving = useMemo(
    () => type === OrganizationTypes.employer || type === OrganizationTypes.company,
    [type]
  );

  const isEmployer = useMemo(
    () => defaultType === OrganizationTypes.employer || defaultType === OrganizationTypes.company,
    [defaultType]
  );

  const currentURL = useMemo(() => {
    if (isEmployerObserving) {
      return `${ROUTES.UNDELIVERABLE_MAIL_REPORT}?employerId=${id}`;
    }
    if (isEmployer) {
      return `${ROUTES.UNDELIVERABLE_MAIL_REPORT}?employerId=${defaultId}`;
    }
    return ROUTES.UNDELIVERABLE_MAIL_REPORT;
  }, [defaultId, id, isEmployer, isEmployerObserving]);
  return currentURL;
};
export default useGetUndeliverableURL;
